import externalMaskingOpenApi from './external-masking-openapi.json';

export const EXTERNAL_MASKING_SCHEMA = externalMaskingOpenApi;
export const EXTERNAL_MASKING_SCHEMA_FILE_NAME = 'external-masking-openapi.json';
